
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trim/stock/[...model]",
      function () {
        return require("private-next-pages/trim/stock/[...model].tsx");
      }
    ]);
  